
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.54 0C8.4 0 8.01.01 6.78.07c-.96.02-1.9.2-2.8.54-.77.29-1.47.74-2.05 1.33C1.34 2.52.89 3.21.6 3.99c-.34.9-.52 1.84-.54 2.8C0 8.02-.01 8.41-.01 11.55c0 3.14.01 3.53.07 4.76.02.96.2 1.9.54 2.8.29.77.74 1.47 1.33 2.05.58.59 1.27 1.04 2.05 1.33.9.33 1.84.52 2.8.54 1.23.06 1.62.07 4.76.07 3.14 0 3.53-.01 4.76-.07.96-.02 1.9-.2 2.8-.54a5.92 5.92 0 003.38-3.38c.34-.9.52-1.84.54-2.8.06-1.23.07-1.62.07-4.76 0-3.14-.01-3.53-.07-4.76-.02-.96-.2-1.9-.54-2.8-.29-.77-.74-1.47-1.33-2.05A5.589 5.589 0 0019.1.61c-.9-.34-1.85-.52-2.81-.54C15.06.01 14.67 0 11.53 0h.01zm0 2.08c3.08 0 3.45.02 4.67.07.73 0 1.46.14 2.14.4 1.01.39 1.8 1.18 2.19 2.19.26.69.39 1.41.4 2.14.06 1.22.07 1.58.07 4.67S21 15 20.94 16.22c-.01.73-.15 1.46-.4 2.14-.19.5-.48.95-.86 1.33-.37.38-.83.68-1.33.86-.69.26-1.42.39-2.15.4-1.23.06-1.59.07-4.67.07s-3.45-.01-4.67-.07c-.73-.01-1.46-.15-2.15-.4-.5-.19-.95-.48-1.33-.86-.39-.37-.69-.83-.87-1.34-.25-.69-.39-1.42-.4-2.15-.04-1.21-.06-1.59-.06-4.66 0-3.07.02-3.45.06-4.68.01-.74.15-1.46.4-2.15.18-.5.48-.96.87-1.33.37-.39.82-.68 1.32-.86.68-.25 1.41-.39 2.14-.4 1.23-.04 1.59-.06 4.67-.06l.04.03-.01-.01zm0 3.54a5.93 5.93 0 00-5.93 5.93c0 3.28 2.65 5.93 5.93 5.93s5.93-2.65 5.93-5.93-2.65-5.93-5.93-5.93zm0 9.78c-2.13 0-3.85-1.72-3.85-3.85S9.41 7.7 11.54 7.7s3.85 1.72 3.85 3.85c0 2.12-1.72 3.85-3.85 3.85zm7.55-10.01c0 .76-.62 1.39-1.38 1.39-.76 0-1.39-.62-1.39-1.38 0-.76.62-1.39 1.38-1.39.76 0 1.38.62 1.39 1.38z","fill":"#1F4053"}})])
          )
        }
      }
    